/* eslint-disable max-len */
export  const convertDatesToEpochUTC=(startDate , timeZone,isStartDate) => {
    const options = { timeZone: timeZone };
  
    let  startTimeUTC = isStartDate?new Date(`${startDate}T00:00:00`).toLocaleString('en-US', options):new Date(`${startDate}T23:59:59`).toLocaleString('en-US', options)
  
    return new Date(startTimeUTC).getTime() / 1000
}

